import { Inserts } from 'app/features/configuratorData/slice/types';
import { ItemsPriceType } from 'app/features/price/slice/types';
import { StockStatusType } from 'app/features/stock/slice/types';

export const transformInsertsDTO: (
  inserts: Inserts[],
  insertsPrice: Array<ItemsPriceType>,
  insertsStockStatus: Array<StockStatusType>,
) => any = (
  inserts: Inserts[],
  insertsPrice: Array<ItemsPriceType>,
  insertsStockStatus: Array<StockStatusType>,
) => {
  const transformedInserts: Inserts[] = inserts.map(item => {
    const stock = insertsStockStatus && insertsStockStatus[0];
    const price = insertsPrice && insertsPrice[0];
    return {
      ...item,
      stockStatus: stock,
      price: price,
    };
  });

  return transformedInserts;
};
